{
    "AddNotification": "Add Notification",
    "EditNotification": "Edit Notification",
    "EnableNotification": "Enable Notification",
    "DisableNotification": "Disable Notification",
    "NotificationNameBusyTime": "Busy Time",
    "NotificationNameAvgAnswerTime": "Average Answer Time (Seconds)",
    "NotificationNameUserNotLoggedIn7Days": "User Not Logged In 7 Days",
    "NotificationNameMissedCalls": "Missed Calls (#)",
    "NotificationNameUserNeverLoggedIn": "Never Logged In",
    "NotificationNameWeeklyInsightsReport": "Weekly Insights Report",
    "NAME": "NotificationsLanguage"
}